import { render, staticRenderFns } from "./PersonaDomiciliosTableView.vue?vue&type=template&id=71b3e3b6&scoped=true"
import script from "./PersonaDomiciliosTableView.vue?vue&type=script&lang=js"
export * from "./PersonaDomiciliosTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3e3b6",
  null
  
)

export default component.exports